export default {
  options: {
    units: {
      kilometers: 'kilometry',
      meters: 'metry',
      miles: 'míle'
    },
    areUnits: {
      sqKms: 'km²',
      hectare: 'hektar',
      sqMeters: 'm²'
    }
  }
}
